import { getBorderFocusStyles } from '../../getBorderFocusStyles';
export var breadcrumbLinkStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    var borderFocusStyles = getBorderFocusStyles(Object.assign({
      variables: siteVariables
    }, p.size === 'smaller' && {
      borderPadding: {
        top: v.linkPaddingTop,
        right: v.linkPaddingRightSmaller,
        bottom: v.linkPaddingBottom,
        left: v.linkPaddingLeftSmaller
      }
    }, p.size === 'small' && {
      borderPadding: {
        top: v.linkPaddingTop,
        right: v.linkPaddingRightSmall,
        bottom: v.linkPaddingBottom,
        left: v.linkPaddingLeftSmall
      }
    }, p.size === 'medium' && {
      borderPadding: {
        top: v.linkPaddingTop,
        right: v.linkPaddingRightMedium,
        bottom: v.linkPaddingBottom,
        left: v.linkPaddingLeftMedium
      }
    }, p.size === 'large' && {
      borderPadding: {
        top: v.linkPaddingTop,
        right: v.linkPaddingRightLarge,
        bottom: v.linkPaddingBottom,
        left: v.linkPaddingLeftLarge
      }
    }));
    return Object.assign({
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      ':visited': {
        color: 'inherit'
      }
    }, borderFocusStyles);
  }
};
//# sourceMappingURL=breadcrumbLinkStyles.js.map
